import React from "react";

export function ScareLogo({ size = 36, withTagline = true }) {
  return (
    <div
      className="flex items-end overflow-hidden max-w-full"
      data-testid="brand-logo"
      style={{ gap: 4, whiteSpace: "nowrap" }}
    >
      <div
        className="st-brand text-white leading-none"
        style={{ fontSize: size, textShadow: "0 0 22px rgba(220,38,38,0.55)" }}
      >
        SCARE<span className="text-[#dc2626]">TICKETS</span>
      </div>
      {withTagline && (
        <span className="st-mono text-[#dc2626]" style={{ fontSize: 8, letterSpacing: 0 }}>
          .CO.UK
        </span>
      )}
    </div>
  );
}
